module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/e2efacdc78bcd7f8fed2fa38b10fa4d3.png";